import { Box, Link, Stack, Typography, type BoxProps } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { Fragment } from "react"
import type { FC } from ".."
import type { LinkType } from "../../graphql/types"

type BreadcrumbsProps = BoxProps & {
  items: LinkType[]
  color?: "light" | "dark"
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ items, color = "dark", sx }) => {
  return (
    <Box
      position="absolute"
      sx={[{ top: 0, left: 0, padding: 3, zIndex: 5 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <Box
        bgcolor={(theme) =>
          color === "dark"
            ? alpha(theme.palette["neutral.900"].main, 0.05)
            : theme.palette["neutral.100"].main
        }
        color={(theme) => theme.palette[color === "dark" ? "neutral.100" : "neutral.700"].main}
        borderRadius={9999}
        px={3}
        py={2}
        sx={{ backdropFilter: "blur(4px)" }}
      >
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          flexWrap="nowrap"
          columnGap={1}
          sx={{
            "overflowX": "auto",
            "msOverflowStyle": "none",
            "scrollbarWidth": "none",

            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {items.map(({ title, uri }, i) => (
            <Fragment key={i}>
              {i !== 0 && (
                <Typography flex="0 0 auto" variant="link.xs">
                  /
                </Typography>
              )}
              {i < items.length - 1 ? (
                <Link
                  flex="0 0 auto"
                  variant="link.xs"
                  href={uri}
                  underline="none"
                  color={(theme) =>
                    theme.palette[color === "dark" ? "neutral.100" : "neutral.700"].main
                  }
                  sx={{ "&:hover": { textDecoration: "underline" } }}
                >
                  {title}
                </Link>
              ) : (
                <Typography
                  flex="0 0 auto"
                  variant="link.xs"
                  component="h2"
                  color={(theme) =>
                    theme.palette[color === "dark" ? "neutral.100" : "neutral.700"].main
                  }
                >
                  {title}
                </Typography>
              )}
            </Fragment>
          ))}
        </Stack>
      </Box>
    </Box>
  )
}
export default Breadcrumbs
